<template>
    <v-container v-if="rack" fluid>
        <v-row class="align-center">
            <v-col cols="1">
                <v-btn color="cyan lighten-4" @click="goBack" small depressed>
                    <v-icon small> mdi-arrow-left </v-icon> back
                </v-btn>
            </v-col>
            <v-col class="text-right">
                <div class="title">
                    Gestione cluster per scaffale
                    <b
                        ><i>{{ rack.description }}</i></b
                    >
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-expansion-panels>
                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            Immagini Scaffalature
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-row>
                                <v-col>
                                    <v-card
                                        class="d-flex flex-column align-center"
                                    >
                                        <v-img
                                            :aspect-ratio="9 / 16"
                                            :width="300"
                                            :src="rack.image"
                                        ></v-img>
                                        <v-card-title class="justify-center">
                                            Riferimento
                                        </v-card-title>
                                    </v-card>
                                </v-col>
                                <v-col>
                                    <v-card
                                        class="d-flex flex-column align-center"
                                    >
                                        <v-img
                                            :aspect-ratio="9 / 16"
                                            :width="300"
                                            :src="rack.image"
                                        ></v-img>
                                        <v-card-title class="justify-center">
                                            Armadio Negozio
                                        </v-card-title>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="text-left">
                <v-btn depressed color="primary" @click="addCluster">
                    <v-icon> mdi-plus </v-icon> Aggiungi
                </v-btn>
                <v-btn depressed color="info" @click="csvImportDialog = true" class="ml-2">
                    <v-icon> mdi-file-upload </v-icon> Importa CSV
                </v-btn>
            </v-col>
            <v-col class="text-right">
                <v-btn
                    outlined
                    color="primary"
                    target="_blank"
                    :to="'/api/rack/' + rack.id + '/export'"
                >
                    <v-icon> mdi-download </v-icon> Scarica
                </v-btn>
                <v-btn depressed color="success" @click="saveClusters">
                    <v-icon> mdi-floppy </v-icon> Salva
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-simple-table class="custom-table">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left">Posizione</th>
                                <th class="text-left" style="width: 120px">
                                    Num Referenze
                                </th>
                                <th class="text-left">Tipologie</th>
                                <th class="text-left">Famiglie</th>
                                <th class="text-left">Prodotti</th>
                                <th class="text-left">Note</th>
                                <th class="text-left">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(item, index) in clusterRackArr">
                                <tr>
                                    <td>
                                        <span style="cursor: pointer" @click="moveUp(index)">
                                            <v-icon small>mdi-arrow-up</v-icon>
                                        </span>
                                        <span style="cursor: pointer" @click="moveDown(index)">
                                            <v-icon small>mdi-arrow-down</v-icon>
                                        </span>
                                        {{ item.floor }}</td>
                                    <td>
                                        <v-text-field
                                            label="Da"
                                            dense
                                            outlined
                                            hide-details
                                            type="number"
                                            v-model="item.ref_num_min"
                                        ></v-text-field
                                        ><br />
                                        <v-text-field
                                            label="A"
                                            dense
                                            outlined
                                            hide-details
                                            type="number"
                                            v-model="item.ref_num_max"
                                        ></v-text-field>
                                    </td>
                                    <td>
                                        <v-row class="align-center">
                                            <v-col cols="9">
                                                <chips-combobox
                                                    label="Tipologie"
                                                    item-value="id"
                                                    item-text="name"
                                                    :data="productTypes"
                                                    multiple
                                                    chips
                                                    v-model:selectedData="
                                                        item.types
                                                    "
                                                    @newType="createProductType"
                                                ></chips-combobox>
                                            </v-col>
                                            <v-col cols="3">
                                                <v-btn
                                                    x-small
                                                    color="primary"
                                                    text
                                                    @click="typeDialog = true"
                                                    ><v-icon small
                                                        >mdi-plus</v-icon
                                                    >
                                                    add</v-btn
                                                >
                                            </v-col>
                                        </v-row>
                                    </td>
                                    <td>
                                        <chips-combobox
                                            label="Sotto Famiglia"
                                            item-value="acl_codcla2"
                                            item-text="acl_descla2"
                                            :data="subFamilies"
                                            multiple
                                            chips
                                            v-model:selectedData="item.families"
                                            @change="onChangeFamilies"
                                        ></chips-combobox>
                                    </td>
                                    <td class="text-center">
                                        Num:
                                        <b>{{ item.products.length }}</b>
                                        <v-btn
                                            x-small
                                            color="primary"
                                            text
                                            @click="
                                                editClusterProduct =
                                                    item.products;
                                                productDialog = true;
                                                onChangeFamilies(item.families);
                                            "
                                            ><v-icon small>mdi-pencil</v-icon>
                                            mod</v-btn
                                        >
                                    </td>
                                    <td>
                                        <v-textarea
                                            name="input-7-1"
                                            filled
                                            label="Note"
                                            rows="1"
                                            auto-grow
                                            v-model="item.note"
                                            hide-details
                                            style="width: 200px"
                                        ></v-textarea>
                                    </td>
                                    <td>
                                        <v-btn
                                            small
                                            color="error"
                                            text
                                            @click="deleteCluster(item.id)"
                                            ><v-icon small>mdi-delete</v-icon>
                                            Elimina</v-btn
                                        >
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="7">
                                        <v-row>
                                            <v-col
                                                class="text-center"
                                                v-for="product in item.products"
                                                :key="product.ar_codart"
                                            >
                                                <v-img
                                                    class="ma-2"
                                                    max-height="200"
                                                    max-width="150"
                                                    :src="
                                                        getImagePath(
                                                            product.ar_codart
                                                        )
                                                    "
                                                >
                                                </v-img>
                                            </v-col>
                                        </v-row>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
        </v-row>
        <v-dialog v-model="typeDialog" max-width="50%">
            <v-card>
                <v-card-title>Aggiungi Tipo</v-card-title>
                <v-card-text>
                    <v-text-field
                        label="Tipo"
                        dense
                        hide-details
                        v-model="newType"
                    ></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="typeDialog = false">Close</v-btn>
                    <v-btn
                        color="primary"
                        text
                        @click="createProductType(newType)"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="productDialog" max-width="90%" height="650">
            <product-cluster-list
                ref="productClusterList"
                :opened="productDialog"
                :subFamiliesIds="subFamiliesIds"
                :familiesIds="fiamiliesIds"
                :selectedProducts="editClusterProduct"
                @selectedChange="editClusterProduct = $event"
            ></product-cluster-list>
        </v-dialog>
        <v-dialog v-model="csvImportDialog" max-width="600">
            <v-card>
                <v-card-title>Importa Cluster da CSV</v-card-title>
                <v-card-text>
                    <v-file-input
                        v-model="csvFile"
                        label="Seleziona file CSV"
                        accept=".csv,.txt"
                        prepend-icon="mdi-file-upload"
                        show-size
                        truncate-length="15"
                    ></v-file-input>
                    <div class="mt-4">
                        <v-alert type="info" outlined>
                            <strong>Formato CSV richiesto:</strong><br>
                            floor,ref_num_min,ref_num_max,note,type_ids,product_codes<br>
                            <small>type_ids: nomi dei tipi separati da virgole (opzionale)<br>
                            product_codes: codici prodotto separati da virgole</small>
                        </v-alert>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="csvImportDialog = false">Annulla</v-btn>
                    <v-btn
                        color="primary"
                        :disabled="!csvFile"
                        :loading="importLoading"
                        @click="importCsv"
                    >
                        Importa
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<style lang="scss" scoped>
.custom-table::v-deep {
    .v-chip {
        .v-chip__content {
            font-size: 10px;
        }
    }
}
</style>
<script>
import ProductImage from "../../../components/ProductImage.vue";
import helpers from "../../../helpers";
import requests from "../../../requests";
import ChipsCombobox from "../components/ChipsCombobox.vue";
import ProductClusterList from "../components/ProductClusterList.vue";

export default {
    name: "ClusterList",
    components: {
        ChipsCombobox,
        ProductClusterList,
        ProductImage,
    },

    watch: {
        typeDialog(val) {
            if (!val) {
                this.newType = null;
                this.editClusterProduct = null;
            }
        },
    },

    computed: {
        headers() {
            return [
                { text: "Piano", value: "piano" },
                { text: "Num Refrenze", value: "description" },
                { text: "Sotto Familia", value: "sottofamiglia" },
                { text: "Prodotti", value: "prodotti" },
            ];
        },
        fiamiliesIds(){
            return _.map(this.rack.families, 'acl_codcla1')
        }
    },

    data() {
        return {
            rack: null,
            typeDialog: false,
            productDialog: false,
            csvImportDialog: false,
            newType: null,
            clusterRackArr: [],
            subFamilies: [],
            productTypes: [],
            subFamiliesIds: [],
            editClusterProduct: null,
            csvFile: null,
            importLoading: false,
        };
    },
    beforeRouteLeave(to, from, next) {
        if (!window.confirm("Hai già salvato?")) {
            next(false);
            return;
        }
        next();
    },
    mounted() {
        console.log("ClusterList Mounted...");

        this.getRackById(this.$route.params.id);
        this.getClusterRack(this.$route.params.id);
        this.getProductTypes();
    },
    methods: {
        getRackById(id) {
            requests.getRack(id).then((response) => {
                this.rack = response.data;
                this.getSubFamilies(_.map(this.rack.families, "acl_codcla1"));
            });
        },

        getClusterRack(id) {
            requests.getClusterRack(id).then((response) => {
                this.clusterRackArr = response.data;
            });
        },
        getSubFamilies(familyIds) {
            requests.getSubFamilies(familyIds).then((response) => {
                this.subFamilies = response.data;
            });
        },
        getFloorNumber() {
            let n = _.maxBy(this.clusterRackArr, "floor");
            if (_.isUndefined(n)) return 1;
            return n.floor + 1;
        },
        addCluster() {
            this.getFloorNumber();
            let a = {
                rack_id: this.rack.id,
                product_type_id: -1,
                ref_num_min: 0,
                ref_num_max: 0,
                families: [],
                products: [],
                types: [],
                floor: this.getFloorNumber(),
                note: null,
            };
            this.clusterRackArr.push(a);
        },

        saveClusters() {
            requests
                .saveClusters(this.rack.id, this.clusterRackArr)
                .then((response) => {
                    this.getClusterRack(this.rack.id);
                    window.Vue.fire({
                        title: "Salvataggio riuscito",
                        html: "Cluster salvati con successo!",
                        type: "success",
                    });
                });
        },

        deleteCluster(id) {
            if (window.confirm("Cancellare il cluster?")) {
                requests.deleteRackCluster(id).then((response) => {
                    this.getClusterRack(this.rack.id);
                });
            }
        },

        createProductType(name) {
            requests.createProductType(name).then((response) => {
                this.productTypes.push(response.data);
            });
            this.typeDialog = false;
        },

        getProductTypes() {
            requests.getProductTypes().then((response) => {
                this.productTypes = response.data;
            });
        },

        goBack() {
            this.$router.go(-1);
        },

        getImagePath(id) {
            return helpers.getImagePath(id);
        },
        onChangeFamilies(item) {
            this.subFamiliesIds = _.map(item, "acl_codcla2");
        },

        recreatePosition() {
            for (let i = 0; i < this.clusterRackArr.length; i++) {
                this.clusterRackArr[i].floor = i+1;
            }
        },

        moveUp(index) {
            let a = this.clusterRackArr[index];
            this.clusterRackArr.splice(index, 1);
            this.clusterRackArr.splice(index - 1, 0, a);
            this.recreatePosition();
        },
        moveDown(index) {
            let a = this.clusterRackArr[index];
            this.clusterRackArr.splice(index, 1);
            this.clusterRackArr.splice(index + 1, 0, a);
            this.recreatePosition();
        },

        importCsv() {
            if (!this.csvFile) return;
            
            this.importLoading = true;
            const data = {
                csv_file: this.csvFile
            };
            
            requests.importClustersFromCsv(this.rack.id, data)
                .then((response) => {
                    this.csvImportDialog = false;
                    this.csvFile = null;
                    this.getClusterRack(this.rack.id);
                    window.Vue.fire({
                        title: "Importazione completata",
                        html: "I cluster sono stati importati con successo dal CSV!",
                        type: "success",
                    });
                })
                .catch((error) => {
                    window.Vue.fire({
                        title: "Errore importazione",
                        html: error.response?.data?.message || "Errore durante l'importazione del CSV",
                        type: "error",
                    });
                })
                .finally(() => {
                    this.importLoading = false;
                });
        },
    },
};
</script>
